export const PROFILE_BASE_URL = 'https://clubhouse.global';

export function profileUrl(handle: string) {
  return `${PROFILE_BASE_URL}/@${handle}`;
}

export function profileHandleLabel(handle: string) {
  return `@${handle}`;
}

export function fallbackHandleFromPlayer(player: { handle?: string | null; id: string; name: string }) {
  if (player.handle) {
    return player.handle;
  }
  const slug = player.name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '')
    .slice(0, 24);
  return slug || player.id.slice(0, 8).toLowerCase();
}
